<template>
    <Widget 
        :title="$t('components.WebMDDashboard.ContactMetricsTitle')"
        :loading="loading"
        :report-mode="reportMode"
        v-resize="onResize">
        <DoughnutChart 
            :stats="stats"
            :countStats="countStats"
            :colors="colors"
            :mobile="mobile"
            :styles="styles"
            :showTooltips="true"
            :showTotal="true"
            :showLabels="true"
            :default-total="totalRecords"
            unit="%" />
    </Widget>
</template>

<script>
/** 
 * ContactMetricsPercentages wraps a DoughnutChart and contains the functions to 
 * parse data from the API.
 * 
 * It represents the number of chat interactions grouped by devices. It also
 * display the total number of interactions from any device in the middle of
 * the chart.
 */

import Widget from '@/components/dashboard/Widget';

import DoughnutChart from '@/components/dashboard/charts/DoughnutChart';

export default {
    name: 'ContactMetricsPercentages',
    data: () => ({ 
        stats: {},
        countStats: {},
        totalRecordsCount: "",
        colors: [],
        mobile: false,
        styles: {
            position: 'relative',
            width: '100%'
        },
        legend: {}
    }),
    props: {
        loading: {
            type: Boolean,
            default: true
        },
        statistics: {
            type: Object,
            required: true,
        },
        totalRecords: {
            type: Number,
            default: null
        },
        reportMode: {
            type: String,
            default: null
        }
    },
    created() {
        const colors = this.$vuetify.theme.isDark ? 
            this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;
        
        this.colors = [
            colors.ddgreen,
            colors.dddarkblue,
            "#F6AA53",
        ]
    },
    mounted() {
        this.updateStats(this.statistics);
    },
    watch: {
        statistics(newData) {
            this.updateStats(newData);
        }
    },
    methods: {
        updateStats(data) {
            if (data) {
                const $t = this.$t.bind(this);
                const labels = Object.keys(data).map(label => $t(`components.WebMDDashboard.${label}Label`));
                this.stats = {
                    labels,
                    datasets: [{
                        data: Object.values(data).filter(val => Number(val) !== 0).map(val => val.percentage),
                        backgroundColor: this.colors,
                        borderWidth: 0
                    }]
                };
                this.countStats = {};
                for(const key in data)
                  this.countStats[$t(`components.WebMDDashboard.${key}Label`)] = data[key].count;
            }
        },
        onResize() {
            this.mobile = window.innerWidth < 600;
        }
    },
    components: { Widget, DoughnutChart }
}
</script>
